module Meevo.Components.Common {

    /** Client-safe app configuration returned by the /appSettingsConfig core endpoint. */
    export interface IAppSettingsConfig {
        geolocationApiKey: string;
        geolocationApiBaseUrl: string;
    }

    export interface IAppSettingsConfigService {
        getConfig(): ng.IPromise<IAppSettingsConfig>;
    }

    /**
     * Fetches client-safe app config (appsettings-derived) from the core /appSettingsConfig
     * endpoint once and caches it. Currently the geolocation (Radar) key/base URL;
     * other client-safe settings can be added to the endpoint over time.
     */
    export class AppSettingsConfigService implements IAppSettingsConfigService {
        private _configPromise: ng.IPromise<IAppSettingsConfig>;

        constructor(
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private appSettings: Meevo.Components.Common.IAppSettings
        ) {
        }

        getConfig(): ng.IPromise<IAppSettingsConfig> {
            if (!this._configPromise) {
                const url = `${this.appSettings.API_ROOT}/appSettingsConfig`;
                this._configPromise = this.dataService.customMethodData(url, "GET", null)
                    .then((response: any) => response.data as IAppSettingsConfig);
            }
            return this._configPromise;
        }

        static factory(): Function {
            let svc = (
                dataService: Meevo.Components.BaseClasses.IDataService,
                appSettings: Meevo.Components.Common.IAppSettings
            ) => new AppSettingsConfigService(dataService, appSettings);

            svc.$inject = ["meevo.components.common.DataService", "meevo.AppSettings"];
            return svc;
        }
    }

    angular.module("meevo.components.common")
        .factory("meevo.components.common.AppSettingsConfigService", AppSettingsConfigService.factory());
}
